import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  LOCALE_ID,
  NgModule,
} from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { environment } from "../environments/environment";

import {
  NgbAccordionModule,
  NgbModule,
  NgbNavModule,
} from "@ng-bootstrap/ng-bootstrap";
import { ScrollToModule } from "@nicky-lenaers/ngx-scroll-to";
import { CarouselModule } from "ngx-owl-carousel-o";

import { ExtrapagesModule } from "./extrapages/extrapages.module";

import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { initFirebaseBackend } from "./authUtils";
import { LayoutsModule } from "./layouts/layouts.module";

import { DatePipe, registerLocaleData } from "@angular/common";
import localeEn from "@angular/common/locales/en";
import localeEs from "@angular/common/locales/es";
import localePt from "@angular/common/locales/pt";
import { NgSelectModule } from "@ng-select/ng-select";
import { IConfig, NgxMaskModule } from "ngx-mask";
import { NgxSpinnerModule } from "ngx-spinner";
import { ToastrModule } from "ngx-toastr";
import { ErrorInterceptor } from "./core/helpers/error.interceptor";
import { FakeBackendInterceptor } from "./core/helpers/fake-backend";
import { JwtInterceptor } from "./core/helpers/jwt.interceptor";
import { LanguageService } from "./core/services/language.service";

registerLocaleData(localePt, "pt-BR");
registerLocaleData(localeEn, "en-US");
registerLocaleData(localeEs, "es-ES");

if (environment.defaultauth === "firebase") {
  // initFirebaseBackend(environment.firebaseConfig);
} else {
  // tslint:disable-next-line: no-unused-expression
  FakeBackendInterceptor;
}

const maskConfig: Partial<IConfig> = {
  validation: true,
};

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}

export function initTranslations(languageService: LanguageService) {
  return () => languageService.init();
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    LayoutsModule,
    AppRoutingModule,
    ExtrapagesModule,
    CarouselModule,
    NgbAccordionModule,
    NgbNavModule,
    ScrollToModule.forRoot(),
    NgbModule,
    NgxSpinnerModule,
    ToastrModule.forRoot(),
    NgxMaskModule.forRoot(maskConfig),
    NgSelectModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FakeBackendInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: "pt-BR" },
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: APP_INITIALIZER,
      useFactory: initTranslations,
      deps: [LanguageService],
      multi: true,
    },
  ],
})
export class AppModule {}
